import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-column gap-1 pb-2" }
const _hoisted_2 = ["onClick", "textContent"]
const _hoisted_3 = ["textContent"]

import { onMounted, onBeforeUnmount, ref, watch } from 'vue';
import Calendar from 'primevue/calendar';
import { useOverageStore, useOrganizationStore, useCustomerSuccessPartnerStore } from '@/store';
import { useRequestCancel, can } from '@/composables';
import { REQUEST, PERMISSIONS } from '@/enum';
import SeatsInUseModal from '@/views/Organizations/Connections/components/SeatsInUseModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Overage',
  setup(__props) {

const overageStore = useOverageStore();
const organizationStore = useOrganizationStore();
const customerSuccessPartnerStore = useCustomerSuccessPartnerStore();
const requestCancel = useRequestCancel();
const filteredOrganizations = ref<string[]>([]);
const month = ref<Date>(new Date());
const showSeats = ref<boolean>(false);
const selectedOrganizationId = ref<number>();

const init = async () => {
  await overageStore.getOverages(month.value, filteredOrganizations.value);
};

const getOrganizationOverages = async () => {
  if (can([PERMISSIONS.OVERAGES_LIST])) {
    overageStore.loading.organization = true;
    await overageStore.getOrganizationOverages(selectedOrganizationId.value as number, month.value, false);
    overageStore.loading.organization = false;
  }
};

// Watches for changes to the CSP or Org filter on the dashboard page and makes a new API call
watch(
  [
    () => customerSuccessPartnerStore.selectedDashboardCustomerSuccessPartners,
    () => organizationStore.organizationsIdsSelected,
  ],
  async () => {
    const selectedOrgIds = new Set(organizationStore.organizationsIdsSelected.map((org) => org.toString()));
    const selectCSPOrgIds = new Set(
      customerSuccessPartnerStore.selectedDashboardCustomerSuccessPartners.flatMap((csp) =>
        csp.organizations.map((org) => org.toString()),
      ),
    );

    filteredOrganizations.value = Array.from(selectedOrgIds).concat(Array.from(selectCSPOrgIds));
    await init();
  },
);

const onDateSelect = (date: Date) => {
  month.value = date;
  init();
};

const toggleSeatsInUseModal = () => {
  showSeats.value = !showSeats.value;
};

const onOrganizationClick = async (id: number) => {
  selectedOrganizationId.value = id;
  await getOrganizationOverages();
  toggleSeatsInUseModal();
};

onMounted(async () => {
  await init();
});

onBeforeUnmount(() => requestCancel.requestSaverAbort(REQUEST.OVERAGES));

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "flex flex-column w-full px-0" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex gap-1 w-full align-items-center pb-2" }, [
          _createElementVNode("span", { class: "material-icons text-color-blue" }, "supervisor_account"),
          _createElementVNode("h2", null, "Seat Count Reporting")
        ], -1)),
        (showSeats.value)
          ? (_openBlock(), _createBlock(SeatsInUseModal, {
              key: 0,
              "organization-id": selectedOrganizationId.value as number,
              onCancel: toggleSeatsInUseModal
            }, null, 8, ["organization-id"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Calendar), {
          modelValue: month.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((month).value = $event)),
          view: "month",
          "show-icon": true,
          "manual-input": false,
          "icon-display": "input",
          class: "mt-3 text-sm",
          "date-format": "MM",
          onDateSelect: onDateSelect
        }, null, 8, ["modelValue"])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        scrollable: "",
        "scroll-height": "300px",
        value: _unref(overageStore).dashboard_overages,
        loading: _unref(overageStore).loading.overage,
        "sort-field": "overUnder",
        "sort-order": -1
      }, {
        empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("No Data to Display", -1)
        ]))]),
        loading: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Loading. Please wait.", -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "organization.name",
            header: "Organization",
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", {
                class: "font-semibold link",
                onClick: ($event: any) => (onOrganizationClick(data.organization.id)),
                textContent: _toDisplayString(data.organization.name)
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "discipline.name",
            header: "Discipline",
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", {
                textContent: _toDisplayString(data.discipline.name)
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "overUnder",
            header: "Seats Over/Under",
            class: "text-center flex justify-content-center",
            sortable: ""
          })
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
}
}

})